module.exports = __webpack_public_path__ + "media/sfx_yay.47541679.mp3";